// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sortable-header-button {
  cursor: pointer;
}

.sortable-header-button:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/SortableHeaderButton/SortableHeaderButton.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,0BAAA;AACJ","sourcesContent":[".sortable-header-button {\n    cursor: pointer;\n}\n\n.sortable-header-button:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
